import { NgModule } from "@angular/core";

import { UppercaseInputValueDirective } from "./uppercase-input-value.directive";

const DIRECTIVES = [UppercaseInputValueDirective];

@NgModule({
	imports: [],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class UppercaseInputValueModule {}
